import { MealType } from 'common/MealTypeUtils';
import { isEqual, sortBy } from 'lodash';
import { createContext, useContext, useState } from 'react';
import { MealTypeMenuBarContextType, MealTypeMenuBarProviderProps } from './types';

const MealTypeMenuBarContext = createContext<MealTypeMenuBarContextType>(undefined);

const createBlankAvailableMealTypes = (): MealType[] => [];

const MealTypeMenuBarProvider = ({ children }: MealTypeMenuBarProviderProps) => {
  const [availableMealTypes, setAvailableMealTypes] = useState(createBlankAvailableMealTypes());
  const [activeMealType, setActiveMealType] = useState<MealType | null>(null);
  const state = {
    availableMealTypes,
    activeMealType,
    setActiveMealType,
    setAvailableMealTypes: (mealTypes: MealType[]) => {
      if (!isEqual(sortBy(mealTypes), sortBy(availableMealTypes))) {
        setAvailableMealTypes(mealTypes);
      }
    },
  };
  return <MealTypeMenuBarContext.Provider value={state}>{children}</MealTypeMenuBarContext.Provider>;
};

const useMealTypeMenuBarContext = () => {
  const context = useContext(MealTypeMenuBarContext);
  if (context === undefined) {
    throw new Error('useMealTypeMenuBarContext must be used within a MealTypeMenuBarContext');
  }
  return context;
};

export { MealTypeMenuBarProvider, useMealTypeMenuBarContext };
